import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "18.5", cy: "17.5", r: "3.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "5.5", cy: "17.5", r: "3.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "15", cy: "5", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17.5V14l-3-3 4-3 2 3h2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bike";
const Bike = memo(themed(Icon));
export {
  Bike
};
//# sourceMappingURL=bike.js.map
